export const modalExtras: { [key: number]: string } = {
  1: 'Insurance',
  2: 'Refill',
  3: 'Sustitution',
  4: 'Washing',
};
